import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
export interface MessageQueue {
  message: string;
  key: string; // A unique key that only this message instance has.
}

@Injectable({
  providedIn: 'root',
})
export class MessageQueueService {
  private _messageSubject = new BehaviorSubject<MessageQueue[]>([]);
  public messages$ = this._messageSubject.asObservable();
  public messages: MessageQueue[] = [];

  public addMessage(message: MessageQueue): void {
    this.messages = [message, ...this.messages];
    this._messageSubject.next(this.messages);
  }
  public removeMessage(key: string): void {
    this.messages = this.messages.filter((message) => message.key !== key);
    this._messageSubject.next(this.messages);
  }
}
